import { Locales } from '@/i18n/config/locales';

export function formatLocale(value: string): string {
    if (value === Locales.nl) { 
      return value
    }
    return Locales.en
}